import script from "./UserOrganizationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UserOrganizationsTable.vue?vue&type=script&setup=true&lang=js"

import "./UserOrganizationsTable.vue?vue&type=style&index=0&id=8c0e947a&lang=scss&scoped=true"
script.__scopeId = "data-v-8c0e947a"

export default script